import * as elkModule from 'elkjs/lib/elk.bundled.js';
import type { ELK as ElkApi, ElkNode } from 'elkjs/lib/elk-api.js';
import { variantKey, type Draft, type Position } from './commands.ts';

// The bundled build is CommonJS: depending on the bundler the class is the module or its `default`.
type ElkClass = new () => ElkApi;
const ELK = ((elkModule as unknown as { default?: ElkClass }).default ?? (elkModule as unknown as ElkClass)) as ElkClass;

export const NODE_WIDTH = 240;
export const NODE_HEIGHT = 84;
const elk = new ELK();

/**
 * «Clean Up Canvas» (BB-114): a layered top-down layout of variants and steps by elkjs; returns positions for every
 * node (variants under `variant__<id>`), which replace the stored layout.
 */
export async function autoLayout(d: Draft): Promise<Record<string, Position>> {
  const children = [...d.variants.map((v) => ({ id: variantKey(v.id), width: NODE_WIDTH, height: 48 })), ...Object.keys(d.steps).map((id) => ({ id, width: NODE_WIDTH, height: NODE_HEIGHT }))];
  const edges = [
    ...d.variants.filter((v) => v.startStepId && d.steps[v.startStepId]).map((v) => ({ id: `${variantKey(v.id)}->${v.startStepId}`, sources: [variantKey(v.id)], targets: [v.startStepId!] })),
    ...Object.values(d.steps).flatMap((s) => s.next.filter((n) => n.stepId && d.steps[n.stepId]).map((n) => ({ id: `${s.id}:${n.port}->${n.stepId}`, sources: [s.id], targets: [n.stepId!] }))),
  ];
  const graph = await elk.layout({
    id: 'root',
    layoutOptions: { 'elk.algorithm': 'layered', 'elk.direction': 'DOWN', 'elk.spacing.nodeNode': '48', 'elk.layered.spacing.nodeNodeBetweenLayers': '56' },
    children,
    edges,
  });
  return Object.fromEntries((graph.children ?? []).map((c: ElkNode) => [c.id, { x: Math.round(c.x ?? 0), y: Math.round(c.y ?? 0) }]));
}
